import { CustomizableValidator } from '../../../types/Validator';
import { ageChecker, getAge } from './helpers';

interface MaxAgeArgs {
  max: number;
}

const errorCode = 'INVALID_MAX_AGE';

const maxAge: CustomizableValidator<MaxAgeArgs> = ({ max }) => value => {
  const date = String(value);
  if (ageChecker(date, max, Math.max)) {
    const age = getAge(date);
    return {
      errorCode,
      age,
      max,
      value: date
    };
  }
};

export { maxAge, errorCode };
